// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2764) return "static/chunks/2764-c2f33a33dd952e6c.js";
	if (chunkId === 5947) return "static/chunks/5947-b2dac34ca7a89c66.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2831 ? "b5c69090" : chunkId) + "." + {"1074":"6ca904249b1f60d6","1652":"670198fdb9203b5e","2831":"6b68c1ba82c2eaed","4678":"e3d32f693a060f79","6091":"8f7901b7b9fd16a6","6102":"1fd2c3a49610e203","6339":"666274b2222ca375","7073":"36372f7137ee9ce4","8400":"d0de43f9d6d74abb","9866":"770fb42c0a0b62c0"}[chunkId] + ".js";
};